var render = function render(){var _vm=this,_c=_vm._self._c;return _c('surround-box',{attrs:{"specialColor":"#082f3e","background":"linear-gradient(270deg, rgba(21, 101, 182, 0) 0%, #3B7AC2 50%, rgba(21, 101, 182, 0) 95%)","title":"生猪年出栏量"}},[_c('div',{staticClass:"chart-box"},[_c('div',{ref:"chart",staticClass:"chart"}),_c('div',{staticClass:"unit"},[_vm._v("单位："+_vm._s(_vm.unit))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }